import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/library/uploads")({
  component: () => <Navigate to="/library" replace />,
});
